export enum actionTypes {
  GET_MODULES_REQUEST = "GET_MODULES_REQUEST",
  GET_MODULES_SUCCESS = "GET_MODULES_SUCCESS",
  GET_MODULES_FAIL = "GET_MODULES_FAIL",
}

export interface GenericAuthStateProps {
  isLoading: boolean;
  status: stateStatusType | null;
  error: string | null;
}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export interface ModuleProps {
  id: string;
  name: string;
  description: string;
  acls: AclsProps[];
  menu?:string;
}
export interface AclsProps {
  route_prefix:string;
  route:string;
  system:string;
  id:string;
  menu:string;
  description:string;
  tabindex:string;
  display:string;
  icon:string;
}
export interface GetModulesRequestAction {
  type: actionTypes.GET_MODULES_REQUEST;
}

export interface GetModulesSuccessAction {
  type: actionTypes.GET_MODULES_SUCCESS;
  payload: ModuleProps[];
}

export interface GetModulesFailureAction {
  type: actionTypes.GET_MODULES_FAIL;
  payload: string;
}

export type ModulesAction =
  | GetModulesRequestAction
  | GetModulesSuccessAction
  | GetModulesFailureAction;
